export default class BaseTemplate<T> {
  protected item: T = undefined as any

  constructor(item: T) {
    this.item = item
  }

  public getItem(): T {
    return this.item
  }
}
